export default __webpack_public_path__ + "static/wax_icon-04d3a6215d9a1271934dceb306f84dd4.png";